import * as fromHours from '../actions/hours.action';

export interface HoursState {
  data: any;
  loaded: Boolean;
  loading: Boolean;
  error: string;
};

export const initialState = {
  data: null,
  loaded: false,
  loading: false,
  error: null
};

export function reducer(state = initialState, action: fromHours.HoursAction): HoursState {
  switch (action.type) {
    case fromHours.GET_HOURS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromHours.GET_HOURS_SUCCESS: {
      const hours = {};
      if (action.payload.length > 0) {
        Object.assign(hours, action.payload.pop());
        Object.assign(hours, action.payload.pop());
        hours['currentHours'] = action.payload;
      }
      return {
        ...state,
        loading: false,
        loaded: true,
        data: hours,
        error: null
      };
    }
    case fromHours.GET_HOURS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/reducers/hours.reducer.ts